// extracted by mini-css-extract-plugin
export var $animation_name = "SupportHeaderTabs-module--$animation_name--4e6a0";
export var Inner = "SupportHeaderTabs-module--Inner--4fdf4";
export var Inner__openMenu = "SupportHeaderTabs-module--Inner__openMenu--3d146";
export var SupportHeader__arrow = "SupportHeaderTabs-module--SupportHeader__arrow--6ba31";
export var SupportHeader__button = "SupportHeaderTabs-module--SupportHeader__button--38f17";
export var Wrapper = "SupportHeaderTabs-module--Wrapper--6cdcf";
export var tab = "SupportHeaderTabs-module--tab--115ed";
export var tab___active = "SupportHeaderTabs-module--tab___active--db455";